import axios from 'axios';
import { getApiRoot } from '../../../constants/ParamountReactConstants';

export function updateExternalSources(authDetails: { id: number; token?: string }[]) {
  return {
    type: 'UPDATE_RECEIVER_EXTERNAL_SOURCES',
    payload: axios.patch(`${getApiRoot()}/external_sources`, authDetails),
  };
}
